/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { cloneDeep, get, isFunction } from "lodash";
import { transformComma } from "../../utils/validator/comma";

import { getDisabled, getData, getValue } from "../../utils/dataComponent";

// components
import Badge from "../Badge";
import Button from "../Button";
import CustomDatePicker from "../CustomDatePicker";
import Input from "../Input";
import Profile from "../Profile";
import ProfileImage from "../Profile/ProfileImage";
import Select from "../Select";
import ExcelUpload from "../ExcelUpload";
import Textarea from "../Textarea";
import AddressSearch from "../AddressSearch";
import Radios from "../Radio/Radios";
import Counter from "../Counter";
import ToggleSwitch from "../ToggleSwitch";
import { CheckBox, CheckBoxes } from "../CheckBox/idnex";
import { dateToViewFormat } from "../../utils/date";
import DatePicker from "../DatePicker";
// import DateTimePicker from "../DatePicker/DateTimePicker";
import TimePicker from "../DatePicker/TimePicker";
import DropzoneComponent from "../Dropzone";
import SelectInput from "../Select-Input";
import SearchSelect from "../Select/SearchSelect";
import SearchEmployees from "../SearchEmployees";
import {
  DEFAULT_DATE_TYPES,
  DEFAULT_TEXT_TYPES,
} from "../../constants/DATA_COMPONENT";
import CardImage from "../Card/CardImage";
import { preventEvent } from "../../utils/element";
import Editor from "../SunEditor";
import ColorPicker from "../ColorPicker";
import Reaction from "../Reaction";
import SearchCompanies from "../SearchCompanies";

const DataComponent = (prop) => {
  const {
    mode = "create",
    field,
    data,
    form,
    onChange: _onChange,
    setForm,
    ...props
  } = prop;

  let fieldItem;
  const [fieldType, setFieldType] = useState(field.type || "text");

  const [list, setList] = useState([]);
  const [defaultValue, setDefaultValue] = useState([]);

  const _setList = async () => {
    const _list = await getData(field, "options.list");
    setList(_list || []);
  };

  const _setDefaultValue = async () => {
    let _defaultValue = await getData(field, "defaultValue");
    if (!_defaultValue && form) {
      const formDefault = get(form, field.key);
      _defaultValue = cloneDeep(formDefault);
    }
    setDefaultValue(_defaultValue);
  };

  const onChange = (a, b, c) => {
    if (isFunction(field.onChange)) {
      field.onChange(a, b, c);
    } else {
      if (_onChange) {
        _onChange(a, b, c);
      }
    }
  };

  useEffect(() => {
    if (isFunction(field.onChanged)) {
      field.onChanged(prop);
    }
  }, [field && field.key && form && form[field.key]]);

  useEffect(() => {
    _setDefaultValue();
  }, [form && form[field.key]]);

  // 추가, select list 변경될 때 list 재호출
  useEffect(() => {
    _setList();
    _setDefaultValue();
  }, [field]);

  // init
  useEffect(() => {
    _setList();
    _setDefaultValue();
    if (!(mode === "create" || mode === "modify")) {
      let type = field[mode];
      // 모드 타입이 없을경우
      if (!type) {
        type = DEFAULT_TEXT_TYPES.includes(field.type) ? "text" : field.type;

        if (field.type === "editor") {
          //  editor 는 editor 로 반환
          // (!form[field.key].includes("<table") && !form[field.key].includes("<p>") && !form[field.key].includes("<div>")) && (type = "text");
        }
        // TODO date type range로 올 경우
        type = DEFAULT_DATE_TYPES.includes(field.type) || (field.options && !field.options.mode) === 'range'
          ? "date"
          : type || field.type;
      }
      setFieldType(type || "text");
    } else {
      setFieldType(field.type || "text");
    }
  }, [mode]);

  const searchSelectOnChange = (data) => {
    _onChange({
      [field.key]: data.value,
    });
  };
  const _action = () => {
    if (field.action) return field.action;
    if (field.onClick) return field.onClick;
    return () => { };
  };

  // type = component
  if (
    (fieldType === "component" || !field.type) &&
    isFunction(field.component)
  ) {
    return field.component({
      field,
      data,
      form,
      onChange,
      setForm,
      defaultValue,
      ...props,
    });
  }

  switch (fieldType.toLocaleLowerCase()) {
    case "text":
      fieldItem = <>{getValue(field, data || form, field.transform) || "-"}</>;
      break;
    case "ellipsis":
      fieldItem = <div className="ellipsis2">{getValue(field, data) || ""}</div>;
      break;
    case "html":
      fieldItem = (
        <span
          style={
            field.style &&
            (isFunction(field.style)
              ? { ...field.style(getValue(field, data), data) }
              : { ...field.style })
          }
          dangerouslySetInnerHTML={{ __html: getValue(field, data) }}
        ></span>
      );
      break;
    case "com":
      fieldItem = <>{transformComma(getValue(field, data))}</>;
      break;
    case "comma":
      fieldItem = <>{transformComma(getValue(field, data))}</>;
      break;
    case "date":
      fieldItem = (
        <>
          {dateToViewFormat(getValue(field, data)) !== "Invalid date"
            ? dateToViewFormat(getValue(field, data))
            : getValue(field, data)}
        </>
      );
      break;
    case "datetime":
      fieldItem = (
        <>{dateToViewFormat(getValue(field, data), "YYYY.MM.DD HH:mm:ss")}</>
      );
      break;
    case "time":
      fieldItem = (
        <>{dateToViewFormat(getValue(field, data), "HH:mm")}</>
      );
      break;
    case "badge":
      fieldItem = (
        <Badge
          color={field.color}
          label={getValue(field, data)}
          size={field.size}
          {...props}
        />
      );
      break;
    case "button":
      fieldItem = (
        <Button
          {...field}
          {...props}
          data={data}
          label={getValue(field, data)}
          onClick={(e) => {
            preventEvent(e);
            _action()(prop);
          }}
        />
      );
      break;

    case "editor":
      const _readOnly = props.readOnly || mode === 'detail' || mode === 'view';
      fieldItem = (
        <Editor
          {...field}
          {...props}
          readOnly={_readOnly}
          data={data}
          value={get(data, field.key, {})}
          name={field.key}
          onChange={onChange}
        />
      );
      break;

    case "input":
    case "password":
    case "number":
      fieldItem = (
        <Input
          name={get(field, "key")}
          type={fieldType.toLocaleLowerCase()}
          placeholder={
            get(field, "options.placeholder") ||
            `${get(field, "title") || get(field, "label")} 입력`
          }
          onKeyPress={get(field, "onKeyPress", () => { })}
          onKeyUp={get(field, "onKeyUp", () => { })}
          onKeyDown={get(field, "onKeyDown", () => { })}
          value={getValue(field, form) || ""}
          onChange={onChange}
          disabled={getDisabled(field, data, form) || props.disabled}
          readOnly={get(field, "readOnly")}
          data={data}
          {...field}
          {...props}
          {...field?.options}
        />
      );
      break;
    case "profileimage":
    case "profile-image":
    case "profileimg":
    case "profile-img":
      fieldItem = (
        <ProfileImage
          field={field}
          data={get(data, field.key, {})}
          {...props}
        />
      );
      break;
    case "profile":
      fieldItem = (
        <Profile
          field={field}
          data={get(data, field.key, {})}
          employeeIdx={get(data, field.key)}
          useEmpty={field?.useEmpty || false}
          {...props} />
      );
      break;
    case "select":
      fieldItem = (
        <Select
          field={field}
          className={field.className}
          name={field.key}
          placeholder={
            get(field, "options.placeholder") ||
            `${get(field, "title")} 선택`
          }
          value={defaultValue}
          onChange={onChange}
          list={list}
          mode={mode}
          form={form}
          disabled={getDisabled(field, data) || props.disabled}
          {...props}
          {...field}
          data={data}
        />
      );
      break;
    case "search-select":
      fieldItem = (
        <SearchSelect
          {...field.options}
          className={field.className}
          name={field.key}
          placeholder={
            get(field, "options.placeholder") ||
            `${get(field, "title")} 입력 및 선택`
          }
          defaultValue={defaultValue}
          onChange={get(field, "onChange") || searchSelectOnChange}
          list={list}
          disabled={getDisabled(field, data) || props.disabled}
          menuPlacement={get(field, "options.menuPlacement")}
          value={defaultValue}
          {...props}
        />
      );
      break;
    case "excel-file":
    case "excelfile":
      fieldItem = <ExcelUpload field={field} {...props} />;
      break;
    case "textarea":
      fieldItem = (
        <Textarea
          name={get(field, "key")}
          placeholder={
            get(field, "options.placeholder") ||
            `${get(field, "title") || get(field, "label")} 입력`
          }
          value={get(form, field.key)}
          maxLength={get(field, "options.maxLength")}
          onChange={onChange}
          {...field}
          {...props}
        />
      );
      break;
    case "address":
      fieldItem = (
        <AddressSearch
          {...field}
          {...props}
          form={form}
          setForm={setForm}
          onChange={onChange}
          disabled={getDisabled(field, form)}
        />
      );
      break;
    case "radio":
    case "radios":
      fieldItem = (
        <Radios
          mode={mode}
          field={field}
          form={form}
          onChange={onChange}
          {...props}
          disabled={getDisabled(field, data)}
        />
      );
      break;
    case "checkbox":
      fieldItem = (
        <CheckBox form={form} onChange={onChange} {...field} {...props} />
      );
      break;
    case "checkboxes":
      fieldItem = (
        <CheckBoxes form={form} onChange={onChange} {...field} {...props} />
      );
      break;
    case "customdatepicker":
      fieldItem = (
        <CustomDatePicker
          field={field}
          defaultValue={defaultValue}
          disabled={getDisabled(field)}
          onChange={onChange}
        />
      );
      break;
    case "datepicker":
      fieldItem = (
        <DatePicker
          field={field}
          defaultValue={defaultValue}
          disabled={getDisabled(field) || mode === 'view'}
          onChange={onChange}
          form={form}
        />
      );
      break;
    case "datetimepicker":
      fieldItem = (
        <DatePicker
          data-enable-time
          field={field}
          defaultValue={defaultValue}
          disabled={getDisabled(field) || mode === 'view'}
          onChange={onChange}
          form={form}
        />
      );
      break;
    case "timepicker":
      fieldItem = (
        <TimePicker
          {...props}
          {...field}
          props={props}
          field={field}
          defaultValue={defaultValue}
          onChange={onChange}
          form={form}
        />
      );
      break;
    case "counter":
      fieldItem = <Counter field={field} data={data} {...props} {...field} />;
      break;
    case "switch":
      fieldItem = <ToggleSwitch {...field} {...props} data={data} />;
      break;
    case "file-upload":
    case "dropzone":
      fieldItem = (
        <DropzoneComponent
          {...field}
          mode={mode}
          form={form}
          field={field}
          onChange={onChange}
        />
      );
      break;
    case "select-input":
      fieldItem = (
        <SelectInput
          {...field.options}
          {...props}
          inputValue={form[field.options.inputValue]}
          defaultValue={defaultValue}
          onChange={onChange}
          name={field.key}
        />
      );
      break;
    case "searchEmployees":
    case "searchemployees":
    case "search-employees":
    case "searchEmployee":
    case "searchemployee":
    case "search-employee":
      fieldItem = (
        <SearchEmployees
          {...field}
          field={field}
          form={form}
          {...props}
          defaultValue={defaultValue}
          onChange={onChange}
        />
      );
      break;
    case "card-image":
      fieldItem = (
        <CardImage
          {...field}
          {...props}
          data={get(data, field.key, {})}
        />
      );
      break;
    case "colorpicker":
      fieldItem = (
        <ColorPicker
          field={field}
          form={form}
          onChange={onChange}
          {...props}
        />
      );

      break;

    case "reaction":
      fieldItem = (
        <Reaction
          field={field}
          form={form}
          onChange={onChange}
          {...props}
        />
      );
      break;

    case "search-companies":
      fieldItem = (
        <SearchCompanies
          {...field}
          field={field}
          form={form}
          {...props}
          defaultValue={defaultValue}
          onChange={onChange}
        />
      );
      break;

    default:
      break;
  }

  if (field && field.before) {
    fieldItem = <>{field.before}{fieldItem}</>;
  }
  if (field && field.after) {
    fieldItem = <>{fieldItem}<p style={{
      fontSize: '12px',
      position: 'relative',
      top: '6px',
      wordBreak: 'keep-all',
      lineHeight: '14px',
      paddingBottom: '10px',
    }}>{field.after}</p></>;
  }

  return fieldItem;
};

export default DataComponent;
